export enum AppNamesEnum {
  SPEEDLABS = "SpeEdLabs",
  STEMLEARN = "STEMLearn",
}

export enum EnvironmentNamesEnum {
  DEVELOPMENT = "development",
  STAGING = "staging",
  PRODUCTION = "production",
}

export enum DevicePlatformsEnum {
  ANDROID = "android",
  IOS = "ios",
  WEB = "web",
}

export enum AppUpdateProcessEnum {
  LIVE_UPDATE = "live-update",
  IN_APP_UPDATE = "in-app-update",
  APK_UPDATE = "apk-update",
  NONE = "none",
}

export enum LiveUpdateStatusesEnum {
  IDLE = "idle",
  DOWNLOADING = "downloading",
  DOWNLOADED = "downloaded",
  APPLYING = "applying",
  ERROR = "error",
}
